import { singularityStore } from "@/store/store";

export function getFutureLayerAppUrl(path: string): string {
  if (!singularityStore.aiServer) {
    throw new Error("no FutureLayer aiServer");
  }

  // no trailing slash on base URL
  const baseUrl = singularityStore.aiServer.url;

  // Ensure path starts with / if provided
  if (path && !path.startsWith('/')) {
    path = '/' + path;
  }

  return baseUrl + path;
}

export function getFutureLayerAppUrlWithReturnTo(path: string): string {
  const url = getFutureLayerAppUrl(path);
  const returnTo = encodeURIComponent(window.location.href);

  // Check if URL already has query params
  const separator = url.includes('?') ? '&' : '?';

  return `${url}${separator}return_to=${returnTo}`;
}
